<template>
  <div ref="reactMountPoint" class="mounting-point" />
</template>

<script>
import React from 'react'
import { InstaWorksheetPage } from 'tms-react'
import { createRoot } from 'react-dom/client'

import 'tms-react/dist/tms-react.css'

export default {
  name: 'InstaOrderPage',
  props: {
  },
  mounted() {
    this.mountReact()
  },
  beforeDestroy() {
    this.reactMountPoint?.unmount?.()
  },
  methods: {
    mountReact() {
      const props = {
        title: this.title,
        value: this.value,
        onChange: v => this.$emit('change', v)
      }
      this.reactMountPoint = createRoot(this.$refs.reactMountPoint)
      const element = React.createElement(InstaWorksheetPage, props)
      this.reactMountPoint.render(element)
    }
  }
}
</script>
<style scoped>
.mounting-point {
  height: calc(100% - 15px);
  width: calc(100% - 30px);
  margin-left: 15px;
  margin-right: 15px;
}
</style>
